import React from "react";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 20px;
  background-color: #f8f9fa;
  min-height: 100vh;
`;

const ContentWrapper = styled.div`
  background: #ffffff;
  max-width: 800px;
  width: 100%;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  line-height: 1.7;
  color: #333;

  @media (max-width: 480px) {
    padding: 24px 16px;
  }
`;

const Title = styled.h1`
  font-size: 1.8rem;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 2px solid #3498db;
  padding-bottom: 10px;
`;

const Introduction = styled.p`
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 40px;
`;

const Section = styled.section`
  margin-bottom: 30px;
`;

const SectionTitle = styled.h2`
  font-size: 1.2rem;
  color: #2c3e50;
  border-left: 4px solid #3498db;
  padding-left: 12px;
  margin-bottom: 15px;
  font-weight: bold;
`;

const SectionContent = styled.p`
  font-size: 1rem;
  margin-bottom: 10px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-size: 0.9rem;

  th,
  td {
    border: 1px solid #e0e0e0;
    padding: 12px;
    text-align: left;
  }

  th {
    background-color: #f1f3f5;
    color: #495057;
    width: 30%;
  }
`;

const WarningBox = styled.div`
  background-color: #fff4e6;
  border-radius: 6px;
  padding: 15px;
  margin-top: 10px;
  font-size: 0.9rem;
  color: #d9480f;
  border: 1px solid #ffd8a8;
`;

function TermsOfService() {
  return (
    <Container>
      <ContentWrapper>
        <Title>利用規約</Title>
        <Introduction>
          この利用規約（以下「本規約」といいます）は、本サービス（以下「当アプリ」といいます）の利用条件を定めるものです。ユーザーの皆さまには、本規約に従って当アプリをご利用いただきます。
        </Introduction>

        <Section>
          <SectionTitle>第1条（適用）</SectionTitle>
          <SectionContent>
            本規約は、当アプリを利用する全てのユーザー（登録ユーザーおよび非登録ユーザーを含みます）に適用されます。
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>第2条（ユーザー登録と管理）</SectionTitle>
          <SectionContent>
            1. 当アプリでの目標投稿には、ユーザー登録が必要です。{"\n"}
            2. ユーザーは、自己の責任においてユーザーIDおよびパスワードを厳重に管理するものとします。{"\n"}
            3. ユーザーID等の管理不十分による損害の責任はユーザーが負うものとし、運営側は一切の責任を負いません。
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>第3条（禁止事項）</SectionTitle>
          <SectionContent>
            当アプリの健全な運営のため、ユーザーは以下の行為を行ってはなりません。これらは登録ユーザー・非登録ユーザーを問わず適用されます。
          </SectionContent>
          <Table>
            <thead>
              <tr>
                <th>カテゴリ</th>
                <th>禁止される行為</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>誹謗中傷</td>
                <td>他者に対する罵倒、差別、名誉毀損、嫌がらせを目的としたコメント</td>
              </tr>
              <tr>
                <td>不適切な投稿</td>
                <td>卑猥な表現、暴力的な表現、または公序良俗に反する内容の投稿</td>
              </tr>
              <tr>
                <td>目的外利用</td>
                <td>宣伝、勧誘、ネットワークビジネス・マルチ商法への勧誘、宗教活動、政治活動</td>
              </tr>
              <tr>
                <td>なりすまし</td>
                <td>他のユーザーや第三者になりすます行為</td>
              </tr>
              <tr>
                <td>不正アクセス</td>
                <td>サーバーやネットワークへの不正アクセス、またはそれを試みる行為</td>
              </tr>
              <tr>
                <td>スパム行為</td>
                <td>同一または類似のコメントを大量に投稿する行為、BOT等による自動投稿</td>
              </tr>
            </tbody>
          </Table>
        </Section>

        <Section>
          <SectionTitle>第4条（運営による管理権限）</SectionTitle>
          <SectionContent>
            運営者は、以下に該当すると判断した場合、事前の通知なく投稿の削除、またはアカウントの停止ができるものとします。
          </SectionContent>
          <WarningBox>
            ※本規約違反、または当アプリの趣旨に著しく反すると判断した場合を含みます。
          </WarningBox>
        </Section>

        <Section>
          <SectionTitle>第5条（AI機能に関する免責）</SectionTitle>
          <SectionContent>
            1. 当アプリでは、AIを用いて目標の「無謀度」をスコアリングする機能を提供していますが、当該スコアはエンターテインメントを目的としたものであり、目標の実現可能性を保証・評価するものではありません。{"\n"}
            2. AIによる判定結果に基づいてユーザーが行った判断・行動について、運営側は一切の責任を負いません。
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>第6条（免責事項）</SectionTitle>
          <SectionContent>
            1. 運営者は、当アプリの内容の正確性、完全性、有用性等について、いかなる保証も行いません。{"\n"}
            2. 当アプリの利用に起因してユーザーに生じた損害について、運営者の故意または重大な過失による場合を除き、運営者は責任を負いません。{"\n"}
            3. ユーザー間またはユーザーと第三者との間で生じたトラブルについて、運営者は一切の責任を負いません。
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>第7条（サービスの変更・中断・終了）</SectionTitle>
          <SectionContent>
            1. 運営者は、ユーザーへの事前通知なく、当アプリの内容を変更し、または提供を中断・終了することができるものとします。{"\n"}
            2. サービスの変更・中断・終了によりユーザーに生じた損害について、運営者は責任を負いません。
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>第8条（個人情報の取扱い）</SectionTitle>
          <SectionContent>
            1. 運営者は、ユーザーの個人情報を、当アプリの運営に必要な範囲でのみ利用します。{"\n"}
            2. 運営者は、法令に基づく場合を除き、ユーザーの同意なく個人情報を第三者に提供しません。{"\n"}
            3. 匿名でのコメント投稿時、連投防止を目的としてIPアドレスを一時的に記録する場合があります。
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>第9条（アクセス解析について）</SectionTitle>
          <SectionContent>
            1. 当アプリでは、利用状況の把握およびサービス改善のため、Google Analyticsを利用することがあります。{"\n"}
            2. Google AnalyticsはCookie等を使用して利用者のアクセス情報を収集しますが、個人を特定する情報は含まれません。{"\n"}
            3. 収集された情報は、Google社のプライバシーポリシーおよびGoogle Analytics利用規約に基づいて管理されます。{"\n"}
            4. Google Analyticsに関する詳細は、Google社の以下のページをご確認ください。
          </SectionContent>
          <SectionContent>
            Googleプライバシーポリシー: https://policies.google.com/privacy{"\n"}
            Google Analytics利用規約: https://marketingplatform.google.com/about/analytics/terms/jp/
          </SectionContent>
        </Section>

        <Section>
          <SectionTitle>第10条（規約の変更）</SectionTitle>
          <SectionContent>
            運営者は、必要と判断した場合には、ユーザーに通知することなく本規約を変更できるものとします。変更後の利用規約は、当アプリ上に掲示した時点から効力を生じるものとします。
          </SectionContent>
        </Section>
      </ContentWrapper>
    </Container>
  );
}

export default TermsOfService;
